<template>
  <component :is="tag" class="pushBanner-wrap">
    <div class="pushBanner" :class="{ 'is-hero': isHero, 'section-inner': !isHero }">
      <div class="pushBanner-img" v-if="blok.image.filename">
        <AssetImage :blok="{ asset: blok.image }" :svgForceDimensions="true" />
      </div>
      <div class="pushBanner-content" :class="{ 'is-centered': !isHero && !blok.image.filename }">
        <h2 class="size-xl">{{ blok.title }}</h2>
        <div v-if="blok.description">{{ blok.description }}</div>
        <SimpleButton class="pushBanner-button" xl :outlined="isHero" :link="blok.cta_link" @click="trackCta">
          {{ blok.cta_label }}
        </SimpleButton>
      </div>
    </div>
  </component>
</template>

<script setup>
const trackingStore = useTrackingStore();

const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
  isHero: {
    type: Boolean,
    required: false,
    default: () => false,
  },
});

const trackCta = () => {
  if (props.isHero) {
    trackingStore.sendTrackingData({
      event: "click.action",
      click: useSnakeCaseFilter(props.blok.cta_label),
      click_chapter1: "hero",
      click_chapter2: "CTA",
    });
  } else {
    trackingStore.sendTrackingData({
      event: "click.action",
      click: useSnakeCaseFilter(props.blok.cta_label),
      click_chapter1: "service_matching_tool_push",
      click_chapter2: "CTA",
      click_chapter3: useSnakeCaseFilter(props.blok.title),
    });
  }
};
</script>

<style lang="scss" scoped>
.pushBanner-wrap {
  z-index: -1;
}

.pushBanner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px;
  font-size: 1rem;
  margin-top: 40px;
  gap: 26px;

  @include for-tablet-landscape-up {
    margin-top: 48px;
    flex-direction: row;
    text-align: left;
  }

  .pushBanner-button {
    margin-top: 1rem;
    width: 100%;

    @include pair-smt;

    @include for-tablet-landscape-up {
      width: fit-content;
    }
  }

  &.is-hero {

    h2 {
      font-size: 1rem;
      margin-bottom: 5px;
    }

    .pushBanner-img {
      display: none;

      @include for-tablet-landscape-up {
        display: block;
      }
    }
  }

  &:not(.is-hero) {
    @include pair-3;
    border-radius: 1.75rem;
    padding: 40px 32px;
    position: relative;
    background-clip: padding-box;
    border: 2px solid transparent;
    box-sizing: border-box;
    background:
      linear-gradient(var(--surface, var(--solid-03)), var(--surface, var(--solid-03))) padding-box,
      linear-gradient(136deg, var(--gradient-start), var(--gradient-end)) border-box;

    @include pair-smt-not-hero;

    @include for-tablet-landscape-up {
      padding: 64px;
    }

    h2 {
      margin-bottom: 12px;
    }

    .pushBanner-button {
      color: white;
      margin-top: 40px;
    }

    .pushBanner-img {
      height: 130px;

      @include for-tablet-landscape-up {
        width: 235px;
      }
    }
  }

}

.pushBanner-img {
  width: 160px;

  img {
    height: 100%;
  }
}

.pushBanner-content {
  &.is-centered {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
  }
}
</style>
